// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const Viewlst_movimiento_hacienda = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_movimiento_hacienda',
        name: 'Movimientos registrados',
        component: Viewlst_movimiento_hacienda,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
